import { combineReducers } from 'redux';
import appReducer, { AppState } from './app/app.reducer';
import { CompareState, reducer as compareReducer } from './compare/compare.reducer';
import pageContextReducer from './pagecontext/pagecontext.reducer';
import productDetailReducer, { ProductDetailState } from './productdetail/productdetail.reducer';

export interface RootState {
  // Static State
  app: AppState;
  pageContext: PageContext;

  // Dynamic State
  productDetail: ProductDetailState;

  // Compare State
  compare: CompareState;
}

export default combineReducers({
  // Static reducers
  app: appReducer,
  pageContext: pageContextReducer,
  productDetail: productDetailReducer,
  compare: compareReducer,
});
